import {createContext} from "react";

export const HierarchyGroupOperationsContext = createContext((arr) => {});
